const desc = `<p class="c0" dir="rtl">
  <span class="c2">לזכר אדם יקר </span><span class="c1 bold">דבר</span
  ><span class="c2">  1934 06 </span>
</p>`;

export default desc;
